import { EpicMoversQueryOption, TopGainersAndLosersPriceOption } from '../../models/fundamental/types';

export const getEpicMoversOptionByStringValue = (valueOption: string): EpicMoversQueryOption => {
  switch (valueOption) {
    case TopGainersAndLosersPriceOption.oneToFive:
      return EpicMoversQueryOption.FROM_1_TO_5;

    case TopGainersAndLosersPriceOption.fiveToFifteen:
      return EpicMoversQueryOption.FROM_5_TO_15;

    case TopGainersAndLosersPriceOption.fifteenToFifty:
      return EpicMoversQueryOption.FROM_15_TO_50;

    case TopGainersAndLosersPriceOption.fiftyToHundred:
      return EpicMoversQueryOption.FROM_50_TO_100;

    case TopGainersAndLosersPriceOption.overHundred:
      return EpicMoversQueryOption.FROM_100;

    default:
      return EpicMoversQueryOption.CUSTOM;
  }
};

export const epicMoversOptionToString = (option: EpicMoversQueryOption): string => {
  switch (option) {
    case EpicMoversQueryOption.FROM_1_TO_5:
      return TopGainersAndLosersPriceOption.oneToFive;

    case EpicMoversQueryOption.FROM_5_TO_15:
      return TopGainersAndLosersPriceOption.fiveToFifteen;

    case EpicMoversQueryOption.FROM_15_TO_50:
      return TopGainersAndLosersPriceOption.fifteenToFifty;

    case EpicMoversQueryOption.FROM_50_TO_100:
      return TopGainersAndLosersPriceOption.fiftyToHundred;

    case EpicMoversQueryOption.FROM_100:
      return TopGainersAndLosersPriceOption.overHundred;

    default:
      return '';
  }
};
